import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LegalPages.css';

const PrivacyPolicy = () => {
    const navigate = useNavigate();
    return (
        <div className="legal-page">
            <button className="legal-back-btn" onClick={() => navigate(-1)}>
                &larr; Back
            </button>
            <div className="glass-panel">
                <h1>Privacy Policy</h1>
                <p className="effective-date">Effective Date: 06/08/2026</p>

                <p><strong>Muthu & Co</strong> is committed to protecting the privacy and security of employee information. This Privacy Policy explains how the <strong>Muthu&Co HRMS</strong> mobile application ("Application") collects, uses, stores, and protects employee information. By using the Application, you acknowledge that you have read and understood this Privacy Policy.</p>

                <h2>1. Information We Collect</h2>
                <ul>
                    <li>Full Name</li>
                    <li>Employee ID</li>
                    <li>Email Address</li>
                    <li>Phone Number</li>
                    <li>Department and Designation</li>
                    <li>Profile Photograph</li>
                    <li>Work Location Information</li>
                    <li>Attendance Records (if applicable)</li>
                    <li>Application Usage Logs</li>
                    <li>Device Information</li>
                    <li>Push Notification Token</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <ul>
                    <li>Employee authentication</li>
                    <li>Employee profile management</li>
                    <li>Attendance management (where applicable)</li>
                    <li>Internal communication</li>
                    <li>Company announcements and notifications</li>
                    <li>Maintain application security</li>
                    <li>Improve internal services</li>
                    <li>Comply with applicable legal obligations</li>
                </ul>

                <h2>3. Data Sharing</h2>
                <p>We do not sell, rent, or trade employee personal information. Information may only be shared within Muthu & Co for administrative purposes, with authorized service providers supporting the Application, or when required by applicable law or government authorities.</p>

                <h2>4. Data Security</h2>
                <p>We implement reasonable administrative, technical, and organizational safeguards to protect employee information against unauthorized access, loss, misuse, alteration, or disclosure. Despite these measures, no electronic storage or internet transmission is completely secure.</p>

                <h2>5. User Responsibilities</h2>
                <ul>
                    <li>Keeping login credentials confidential.</li>
                    <li>Reporting unauthorized account access immediately.</li>
                    <li>Ensuring the information they provide is accurate and up to date.</li>
                </ul>

                <h2>6. Data Retention</h2>
                <p>Employee information will be retained only as long as necessary to maintain employment records, comply with legal and regulatory requirements, and fulfill legitimate business purposes. Data may be securely deleted when no longer required.</p>

                <h2>7. Permissions Used</h2>
                <ul>
                    <li><strong>Camera</strong> – For profile photo or attendance verification (if applicable).</li>
                    <li><strong>Location</strong> – For work location verification and attendance purposes.</li>
                    <li><strong>Storage/Photos</strong> – For uploading profile pictures or related documents.</li>
                    <li><strong>Notifications</strong> – To receive company announcements and important updates.</li>
                    <li><strong>Internet Access</strong> – To communicate securely with company servers.</li>
                </ul>

                <h2>8. Children's Privacy</h2>
                <p>The Application is intended exclusively for authorized employees and is not designed for individuals under 18 years of age.</p>

                <h2>9. Changes to this Privacy Policy</h2>
                <p>Muthu & Co reserves the right to modify this Privacy Policy at any time. Updated versions will be published within the Application and will become effective immediately upon publication.</p>

                <h2>10. Consent</h2>
                <p>By accessing or using the Muthu&Co HRMS Application, you consent to the collection, processing, storage, and use of your information as described in this Privacy Policy.</p>

                <div className="legal-contact-box">
                    <strong>Company:</strong> Muthu & Co<br />
                    <strong>Application:</strong> Muthu&Co HRMS<br />
                    <strong>Email:</strong> <a href="mailto:p2pswap786@gmail.com">p2pswap786@gmail.com</a>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;